//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            dialogVisible: false,
            csrftoken: document.head.querySelector('meta[name="csrf-token"]').content,
        };
    },

    methods: {
        show () {
            this.dialogVisible = true;
        },

        hide () {
            this.dialogVisible = false;
        }
    }
};
